import { baseApi } from '@klp/core/api';
import { generateApiRoute } from '@klp/core/api/helpers';
import type { ReportModel } from '../classes/Report.model';

const reportApiName = 'config';

const reportApiRoutes = {
    report: () => generateApiRoute([reportApiName, 'report']),
};

export const reportRtkApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getReports: build.query<Array<ReportModel>, void>({
            query: () => ({
                url: reportApiRoutes.report(),
                method: 'GET',
            }),
            providesTags: ['Config'],
        }),
    }),
});

export const { useGetReportsQuery, useLazyGetReportsQuery } = reportRtkApi;
